/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-header[_ngcontent-%COMP%] {\n  display: inline; }\n\n.fa-exclamation-triangle[_ngcontent-%COMP%] {\n  font-size: 20pt; }"];
export { styles as styles };
